import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import useFetch from "../useFetch";
import { getStoredUser, refreshStoredUser } from "../auth";
import { apiRequest } from "../utils/api";
import "./StaticPages.css";

const money = (amount, currency = "USD") => `${currency} ${Number(amount || 0).toFixed(2)}`;

const getCheckoutSessionId = () => {
  const searchSessionId = new URLSearchParams(window.location.search).get("session_id");

  if (searchSessionId) {
    return searchSessionId;
  }

  const hash = window.location.hash.startsWith("#") ? window.location.hash.slice(1) : window.location.hash;

  return new URLSearchParams(hash).get("session_id");
};

const PaymentSuccess = () => {
  const [invoiceUrl, setInvoiceUrl] = useState(process.env.REACT_APP_BASE_API_URL + "/employer/invoices/latest");
  const [syncMessage, setSyncMessage] = useState("Confirming payment...");
  const [syncError, setSyncError] = useState(null);
  const { response } = useFetch(invoiceUrl);
  const invoice = response?.invoice;

  useEffect(() => {
    const sessionId = getCheckoutSessionId();

    if (!sessionId) {
      setSyncMessage("Payment received. Invoice details will appear after confirmation.");
      return;
    }

    let isActive = true;

    apiRequest("/employer/billing/checkout-session/sync", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id: sessionId }),
    })
      .then((data) => {
        if (!isActive) return;

        const storedUser = getStoredUser();

        if (storedUser && data?.user) {
          refreshStoredUser({
            ...storedUser,
            available_job_posts: data.user.available_job_posts,
            posting_mode: data.user.posting_mode,
          });
        }

        setSyncMessage(data?.message ?? "Payment synced successfully.");
        setInvoiceUrl(process.env.REACT_APP_BASE_API_URL + "/employer/invoices/latest?_=" + Date.now());
      })
      .catch((error) => {
        if (!isActive) return;

        setSyncError(error.message);
        setSyncMessage("Payment was received, but account access is still syncing.");
      });

    return () => {
      isActive = false;
    };
  }, []);

  const paymentItems = [
    { id: "plan", label: "Selected Plan", value: invoice?.item_name ?? "Employer Plan" },
    { id: "amount", label: "Amount", value: invoice ? money(invoice.total, invoice.currency) : "Pending" },
    { id: "status", label: "Status", value: invoice?.status ?? "Payment Successful" },
  ];

  return (
    <section className="static-page-section">
      <div className="auto-container">
        <div className="static-hero">
          <span className="icon success"><i className="la la-check"></i></span>
          <h1>Payment Successful</h1>
          <p>{syncMessage}</p>
          {syncError && <div className="alert alert-danger"><strong>{syncError}</strong></div>}
          <div className="static-actions">
            <Link to="/employee-post-job" className="theme-btn btn-style-one">Post a Job</Link>
            <Link to="/employee-plans" className="theme-btn btn-style-three">View Plan</Link>
          </div>
        </div>

        <div className="static-info-grid">
          {paymentItems.map((item) => (
            <div className="static-info-card" key={item.id}>
              <span>{item.label}</span>
              <strong>{item.value}</strong>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PaymentSuccess;
